import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Product } from '../Module/Product.model';
import { ProductService } from '../service/product.service';
import { FormsModule,ReactiveFormsModule,FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { StateService } from '../service/state.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { PopupService } from '../service/popup.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.css'],
  
   
})
export class AddProductComponent implements OnInit {
  imageBlobUrl: string | null = null;
  imageLoading: boolean = false;
    encodeUrl(url: string): string {
      return encodeURIComponent(url);
    }
  
  newProduct : Product =new Product();
  isAddingProduct = false;
  showGlobalLoader = false;
  formControl!: FormGroup;
  title : string = '';
  btnTitle : string = '';
  
  // Dropdown lists
  units = ['M', 'P', 'KG'];
  categories: string[] = [];
  subCategories: string[] = [];
  productFamilies: string[] = [];
  
  // Image upload properties
  selectedFile: File | null = null;
  imagePreview: string | null = null;
  uploadInProgress = false;
  uploadSuccess = false;
  uploadError: string | null = null;
  // Image click actions overlay + modal
  showImageActions = false;
  showImageModal = false;
  fullImageSrc: string | null = null;
  
  productIdFromUrl: number | null = null;
  
  constructor(
    private productService: ProductService,
    private stateService: StateService,
    private router: Router,
    private authService: AuthService,
    private popupService: PopupService,
    private http: HttpClient,
    private route: ActivatedRoute
  ) {
    
  }
  async ngOnInit(): Promise<void> {
    this.formControl = new FormGroup({
      codeBare: new FormControl('',[Validators.required,this.barcodeValidator()]),
      name: new FormControl('',[Validators.required]),
      quantity: new FormControl('',[Validators.required]),
      price : new FormControl('',[Validators.required]),
      purchasePrice : new FormControl('',[Validators.required]),
      unit : new FormControl('',[Validators.required]),
      description : new FormControl('',)
    });

    this.route.queryParamMap.subscribe(async params => {
      const pid = params.get('productid');
      this.productIdFromUrl = pid ? Number(pid) : null;
      if (this.productIdFromUrl) {
        this.btnTitle = 'Modifier';
        this.title = 'Modifier le produit';
        this.showGlobalLoader = true;
        // Load product data first
        this.productService.getProduct(this.productIdFromUrl).subscribe({
          next: (product) => {
            this.newProduct = product;
            if (product.category) {
              // Load categories and sub-categories
              this.productService.getSubCategories(product.category).subscribe({
                next: (subs: string[]) => {
                  this.subCategories = subs;
                  // Load product families if subCategory exists
                  if (product.subCategory) {
                    this.productService.getProductFamilies(product.category!, product.subCategory).subscribe({
                      next: (families: string[]) => {
                        this.productFamilies = families;
                      },
                      error: (error) => {
                        console.warn('Failed to load product families:', error);
                        this.productFamilies = [];
                      }
                    });
                  }
                },
                error: (error) => {
                  console.warn('Failed to load sub-categories:', error);
                  this.subCategories = [];
                }
              });
            }
            this.showGlobalLoader = false;
            // Load image in a non-blocking way
            if (product.imageUrl) {
              let objectKey = product.imageUrl;
              if (product.imageUrl.startsWith('http')) {
                const extracted = this.extractObjectKey(product.imageUrl);
                if (extracted) objectKey = extracted;
              }
              this.newProduct.imageUrl = objectKey;
              this.imageLoading = true;
              setTimeout(() => this.fetchProductImageByObjectKey(objectKey), 0);
            } else {
              this.imageLoading = false;
            }
          },
          error: () => {
            this.showGlobalLoader = false;
          }
        });
      } else if(this.router.url === '/addProduct') {
        this.btnTitle = 'Ajouter';
        this.title = 'Ajouter un produit';
      }
    });
    // Load categories on init
    this.loadCategories();
  }

  loadCategories(): void {
    this.productService.getCategories().subscribe({
      next: (cats: string[]) => {
        this.categories = cats;
      },
      error: (error) => {
        console.warn('Failed to load categories:', error);
        this.categories = [];
      }
    });
  }

  onCategoryChange(category: string | undefined): void {
    if (!category) {
      this.subCategories = [];
      this.productFamilies = [];
      this.newProduct.subCategory = '';
      this.newProduct.productFamily = '';
      return;
    }

    // Only clear subCategory if the category is actually changed by the user
    if (this.newProduct.category !== category) {
      this.newProduct.subCategory = '';
      this.newProduct.productFamily = '';
    }
    this.newProduct.category = category;
    this.subCategories = [];
    this.productFamilies = [];

    this.productService.getSubCategories(category).subscribe({
      next: (subs: string[]) => {
        this.subCategories = subs;
        // If editing, and the subCategory exists in the list, keep it selected
        if (this.newProduct.subCategory && !subs.includes(this.newProduct.subCategory)) {
          this.newProduct.subCategory = '';
          this.productFamilies = [];
        } else if (this.newProduct.subCategory) {
          // Load product families if subCategory is already set (editing mode)
          this.productService.getProductFamilies(category, this.newProduct.subCategory).subscribe({
            next: (families: string[]) => {
              this.productFamilies = families;
            },
            error: (error) => {
              console.warn('Failed to load product families:', error);
              this.productFamilies = [];
            }
          });
        }
      },
      error: (error) => {
        console.warn('Failed to load sub-categories:', error);
        this.subCategories = [];
      }
    });
  }

  onSubCategoryChange(subCategory: string | undefined): void {
    if (!subCategory) {
      this.productFamilies = [];
      this.newProduct.productFamily = '';
      return;
    }

    const category = this.newProduct.category;
    if (!category) {
      return;
    }

    this.productFamilies = [];

    this.productService.getProductFamilies(category, subCategory).subscribe({
      next: (families: string[]) => {
        this.productFamilies = families;
        // If editing and the productFamily exists in the list, keep it selected
        if (this.newProduct.productFamily && !families.includes(this.newProduct.productFamily)) {
          this.newProduct.productFamily = '';
        }
      },
      error: (error) => {
        console.warn('Failed to load product families:', error);
        this.productFamilies = [];
      }
    });
  }
  loadProduct(): void {
    const productCode = this.stateService.getProductCode();
    if (productCode !== undefined) {
      this.imageLoading = true;
      this.productService.getProduct(productCode).subscribe(product => {
        this.newProduct = product;
        // Load subcategories for the product's category
        if (product.category) {
          this.productService.getSubCategories(product.category).subscribe({
            next: (subs: string[]) => {
              this.subCategories = subs;
              // Load product families if subCategory exists
              if (product.subCategory) {
                this.productService.getProductFamilies(product.category!, product.subCategory).subscribe({
                  next: (families: string[]) => {
                    this.productFamilies = families;
                  },
                  error: (error) => {
                    console.warn('Failed to load product families:', error);
                    this.productFamilies = [];
                  }
                });
              }
            },
            error: (error) => {
              console.warn('Failed to load sub-categories:', error);
              this.subCategories = [];
            }
          });
        }
        if (product.imageUrl) {
          let objectKey = product.imageUrl;
          if (product.imageUrl.startsWith('http')) {
            const extracted = this.extractObjectKey(product.imageUrl);
            if (extracted) objectKey = extracted;
          }
          this.newProduct.imageUrl = objectKey;
          // Fetch image in parallel
          this.fetchProductImageByObjectKey(objectKey);
        } else {
          this.imageLoading = false;
        }
      }, err => {
        this.imageLoading = false;
      });
    } else {
      console.error('Product code is undefined');
    }
  }

  // Extract objectKey from imageUrl (e.g., http://localhost:9100/products/1111/abc.webp => products/1111/abc.webp)
  extractObjectKey(imageUrl: string): string | null {
    try {
      // Remove protocol and host
      const url = new URL(imageUrl);
      // Remove leading slash
      return url.pathname.startsWith('/') ? url.pathname.substring(1) : url.pathname;
    } catch (e) {
      return null;
    }
  }

  fetchProductImageByObjectKey(objectKey: string): void {
    // Use environment API base URL to ensure correct backend address (dynamic)
    // environment.apiUrl already includes /api, so we just append the path
    const url = `${environment.apiUrl}/files/download-webp?objectKey=${encodeURIComponent(objectKey)}`;
    this.imageLoading = true;
    this.http.get(url, { responseType: 'blob', withCredentials: true }).subscribe(blob => {
      this.imageBlobUrl = URL.createObjectURL(blob);
      this.imageLoading = false;
    }, err => {
      this.imageBlobUrl = null;
      this.imageLoading = false;
    });
  }
  addProduct() {
    this.isAddingProduct = true;
    this.showGlobalLoader = true;
    // If an image is selected but not uploaded, upload it first
    if (this.selectedFile && !this.uploadSuccess) { 
      this.uploadImage(true); // Will call finishAddProduct after upload
    } else {
      this.finishAddProduct();
    }
  }

  // Helper to finish product addition
  finishAddProduct() {
    this.productService.addProduct(this.newProduct).subscribe({
      next: (data: Product) => {
        this.newProduct = new Product();
        this.stateService.showSnackbar('Produit ajouté avec succès.');
        this.router.navigate(['/']);
        this.isAddingProduct = false;
        this.showGlobalLoader = false;
      },
      error: (error) => {
        this.isAddingProduct = false;
        this.showGlobalLoader = false;
      }
    });
  }

  // Modify uploadImage to optionally continue to add product
  uploadImage(continueToAddProduct: boolean = false): void {
    this.showGlobalLoader = true;
    if (!this.selectedFile || !this.newProduct.codeBare) {
      this.uploadError = 'Veuillez sélectionner une image et remplir le code barre.';
      if (continueToAddProduct) this.isAddingProduct = false;
      return;
    }

    this.uploadInProgress = true;
    this.uploadError = null;
    this.uploadSuccess = false;

    const fileName = this.selectedFile.name;
    const contentType = this.selectedFile.type;
    const codeBare = this.newProduct.codeBare;

    // Step 1: Get presigned upload URL
    this.productService.presignUpload(fileName, contentType, codeBare).subscribe({
      next: (presignResponse: any) => {
        // Step 2: Upload file using presigned URL
        const xhr = new XMLHttpRequest();

        xhr.onload = () => {
          this.showGlobalLoader = false;
          if (xhr.status === 200) {
            // Store only objectKey, not fileUrl
            this.newProduct.imageUrl = presignResponse.objectKey;
            this.uploadSuccess = true;
            this.uploadInProgress = false;
            this.stateService.showSnackbar('✓ Image téléchargée avec succès!');
            if (continueToAddProduct) {
              this.finishAddProduct();
            }
          } else {
            this.uploadError = `Erreur lors du téléchargement: ${xhr.status}`;
            this.uploadInProgress = false;
            if (continueToAddProduct) this.isAddingProduct = false;
          }
        };

        xhr.onerror = () => {
          this.showGlobalLoader = false;
          this.uploadError = `Erreur réseau: ${xhr.statusText}`;
          this.uploadInProgress = false;
          if (continueToAddProduct) this.isAddingProduct = false;
        };

        xhr.upload.onprogress = (event: ProgressEvent) => {
          if (event.lengthComputable) {
            const percentComplete = (event.loaded / event.total) * 100;
            // Optionally show progress
          }
        };

        xhr.open('PUT', presignResponse.uploadUrl);
        xhr.setRequestHeader('Content-Type', contentType);
        xhr.send(this.selectedFile);
      },
      error: (error: any) => {
        this.showGlobalLoader = false;
        this.uploadError = error.error?.message || 'Erreur lors de la demande d\'URL de téléchargement';
        this.uploadInProgress = false;
        if (continueToAddProduct) this.isAddingProduct = false;
      }
    });
  }
    barcodeValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const valid = /^\d{13}$/.test(control.value) || /^\d{12}$/.test(control.value) || /^\d{10}$/.test(control.value);
        return valid ? null : { invalidBarcode: { value: control.value } };
      }
    }
         updateProduct() {
       const productCode = this.newProduct.codeBare;
       if (productCode !== undefined) {
         const quantity = this.newProduct.quantity ?? 0;
         
         // SECURITY: Check if quantity is being reduced
         // Get current product quantity first
         this.productService.getProduct(productCode).subscribe(currentProduct => {
           const currentQuantity = currentProduct.quantity ?? 0;
           
           if (quantity < currentQuantity) {
             // Check if user is admin
             const user = this.authService.getUser();
             const isAdmin = user?.role === 'ADMIN';
             
                                       if (!isAdmin) {
                // BLOCK quantity reduction for non-admin users
                this.popupService.showDanger('⚠️ Seuls les administrateurs peuvent réduire les quantités de produits.');
               
               // Still make the API call so backend can send notification to admins
               // The backend will throw an AccessDeniedException and send notification
                              this.productService.updateProduct(this.newProduct).subscribe({
                  next: (data: Product) => {
                    // This should not happen for non-admin users
                    this.newProduct = new Product();
                    this.stateService.showSnackbar('Produit modifié avec succès.');
                    this.router.navigate(['/']);
                  },
                  error: (error) => {
                    // Expected error - backend blocked the request and sent notification
                    this.popupService.showDanger('⚠️ Seuls les administrateurs peuvent réduire les quantités de produits.');
                  }
                });
               return;
            } else {
              // Admin is reducing quantity - log it for audit purposes
              // Admin actions are logged silently
            }
          }
          
          // Proceed with update if quantity is not reduced OR if user is admin
          this.productService.updateProduct(this.newProduct).subscribe((data:Product)=>{
            this.newProduct = new Product();
            this.stateService.showSnackbar('Produit modifié avec succès.');
            this.router.navigate(['/']);
          });
        });
      }
    }
         updateProductQuantity() { 
       const productCode = this.stateService.getProductCode();
       if (productCode !== undefined) {
         const quantity = this.newProduct.quantity ?? 0;
         
         // SECURITY: Check if quantity is being reduced
         // Get current product quantity first
         this.productService.getProduct(productCode).subscribe(currentProduct => {
           const currentQuantity = currentProduct.quantity ?? 0;
           
           if (quantity < currentQuantity) {
             // Check if user is admin
             const user = this.authService.getUser();
             const isAdmin = user?.role === 'ADMIN';
             
                                                   if (!isAdmin) {
               // BLOCK quantity reduction for non-admin users
              
              // Show error message to user immediately
              this.popupService.showDanger('⚠️ Seuls les administrateurs peuvent réduire les quantités de produits.');
              
              // Still make the API call so backend can log the attempt
              this.productService.updateProductQuantity(productCode, quantity).subscribe({
                next: (data: Product) => {
                  // This should not happen for non-admin users
                  this.newProduct = new Product();
                  this.stateService.showSnackbar('Quantité modifiée avec succès.');
                  this.router.navigate(['/']);
                },
                error: (error) => {
                  // Expected error - backend blocked the request
                }
              });
              return;
            } else {
              // Admin is reducing quantity - log it for audit purposes
              // Admin actions are logged silently
            }
          }
          
          // Proceed with update if quantity is not reduced
          this.productService.updateProductQuantity(productCode, quantity).subscribe((data:Product)=>{
            this.newProduct = new Product();
            this.stateService.showSnackbar('Quantité modifiée avec succès.');
            this.router.navigate(['/']);
          });
        });
      }
    }
    
    updateProductByCodeBare() {
      const productCode = this.productIdFromUrl;
      console.log('[DEBUG] updateProductByCodeBare called');
      console.log('[DEBUG] productCode:', productCode);
      console.log('[DEBUG] newProduct:', this.newProduct);
      if (productCode !== null && productCode !== undefined) {
        const quantity = this.newProduct.quantity ?? 0;
        this.productService.getProduct(productCode).subscribe(async currentProduct => {
          const currentQuantity = currentProduct.quantity ?? 0;
          const proceedUpdate = () => {
            this.isAddingProduct = true;
            this.showGlobalLoader = true;
            console.log('[DEBUG] Calling updateProductByCodeBare with:', productCode, this.newProduct);
            this.productService.updateProductByCodeBare(productCode, this.newProduct).subscribe({
              next: (data: Product) => {
                console.log('[DEBUG] Update success:', data);
                this.newProduct = new Product();
                this.stateService.showSnackbar('Produit modifié avec succès.');
                this.router.navigate(['/']);
              },
              error: (err) => {
                console.error('[DEBUG] Update error:', err);
                this.stateService.showSnackbar('Erreur lors de la modification du produit.');
              },
              complete: () => {
                this.isAddingProduct = false;
                this.showGlobalLoader = false;
                console.log('[DEBUG] Update complete');
              }
            });
          };
          if (quantity < currentQuantity) {
            const user = this.authService.getUser();
            const isAdmin = user?.role === 'ADMIN';
            if (!isAdmin) {
              this.popupService.showDanger('⚠️ Seuls les administrateurs peuvent réduire les quantités de produits.');
              proceedUpdate();
              return;
            } else {
              // Admin actions are logged silently
            }
          }
          if (this.selectedFile && !this.uploadSuccess) {
            // Compress image before upload (same as add product)
            try {
              // @ts-ignore
              const imageCompression = (await import('browser-image-compression')).default;
              const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1024,
                useWebWorker: true
              };
              const compressedFile = await imageCompression(this.selectedFile, options);
              this.selectedFile = new File([compressedFile], this.selectedFile.name, { type: compressedFile.type });
              this.uploadError = null;
              this.uploadSuccess = false;
            } catch (err) {
              this.uploadError = 'Erreur lors de la compression de l\'image.';
            }
            this.uploadImage(false);
            // Wait for upload to finish, then call proceedUpdate
            const checkUpload = setInterval(() => {
              if (this.uploadSuccess) {
                clearInterval(checkUpload);
                proceedUpdate();
              } else if (this.uploadError) {
                clearInterval(checkUpload);
                // Optionally show error
              }
            }, 200);
          } else {
            proceedUpdate();
          }
        });
      }
    }
    
      addOrUpdateProduct() {
    console.log('[DEBUG] addOrUpdateProduct called, router.url:', this.router.url);
    if(this.router.url.startsWith('/updateProduct')) {
      this.updateProductByCodeBare();
    } else if(this.router.url.startsWith('/addProduct')) {
      this.addProduct();
    } 
  }

  // Image upload methods
  async onImageSelected(event: Event) {
    // browser-image-compression import must be at the top of the file
    // @ts-ignore
    const imageCompression = (await import('browser-image-compression')).default;
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }
    const file = input.files[0];
    if (!file.type.startsWith('image/')) {
      this.uploadError = 'Veuillez sélectionner un fichier image.';
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      this.uploadError = 'Fichier trop volumineux. Maximum 10 MB.';
      return;
    }

    this.imageLoading = true;
    // Compress image before upload
    try {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1024,
        useWebWorker: true
      };
      const compressedFile = await imageCompression(file, options);
      this.selectedFile = new File([compressedFile], file.name, { type: compressedFile.type });
      this.uploadError = null;
      this.uploadSuccess = false;

      // Show preview
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagePreview = e.target.result;
        this.imageLoading = false;
      };
      reader.readAsDataURL(this.selectedFile);
    } catch (err) {
      this.uploadError = 'Erreur lors de la compression de l\'image.';
      this.imageLoading = false;
    }
  }

  clearImage(): void {
    this.selectedFile = null;
    this.imagePreview = null;
    this.uploadSuccess = false;
    this.uploadError = null;
    this.newProduct.imageUrl = undefined;
  }

  // Navigation
  cancel() {
    this.router.navigate(['/']);
  }

  toggleImageActions(event: Event) {
    this.showImageActions = !this.showImageActions;
    event.stopPropagation();
  }

  viewFullImage(event: Event) {
    this.showImageModal = true;
    this.fullImageSrc = this.imagePreview ? this.imagePreview : (this.imageBlobUrl ? this.imageBlobUrl : null);
    event.stopPropagation();
  }

  closeImageModal() {
    this.showImageModal = false;
  }

}

